module.exports = __webpack_public_path__ + "img/br.aa1e61da.svg";